export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_02.b7c3f916.jpg";